import React from 'react';
import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import {FaUserCircle} from "react-icons/fa";
import {NavLink} from "react-router-dom";
import FluxerLogo from "../../images/Group 220.svg";
import {useDispatch, useSelector} from "react-redux";
import {getUserInfo} from "../../redux-store/selectors";
import {checkSuperUser, checkUserPermissions, logOutUser} from "../authHelpers";
import {set2FAModalState} from "../../redux-store/globalData";
import TwoFaModal from "../ApplicationComponent/TwoFAModal";

const NavBar = () => {
    const userInfo = useSelector(getUserInfo)

    const dispatch = useDispatch()

    const handleLogOut = () => {
        logOutUser()
    }

    const handleOpen2FAModal = () => {
        dispatch(set2FAModalState(true))
    }

    return (
        <Navbar className={"bg-dark-navbar sticky-top"} expand="lg">
            <Container fluid>
                <Navbar.Brand className="navbar-brand d-lg-none" href={"/"}><img src={FluxerLogo}/></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavLink to={"/"} className={"nav-link"}>Home</NavLink>
                        {checkUserPermissions(userInfo) && <>
                            {!checkSuperUser(userInfo) &&
                                <NavLink to={"/installations"} className={"nav-link"}>Instalacije</NavLink>}
                            <NavLink to={"/users"} className={"nav-link"}>Korisnici</NavLink>
                            <NavLink to={"/devices"} className={"nav-link"}>Uređaji</NavLink>
                            <NavLink to={"/tables"} className={"nav-link"}>Tabele</NavLink>
                            <NavLink to={"/triggers"} className={"nav-link"}>Okidači</NavLink>
                        </>}

                    </Nav>
                    <Navbar.Brand className="d-none d-lg-block mx-auto" href={"/"}><img
                        src={FluxerLogo}/></Navbar.Brand>
                    <Nav>
                        <NavDropdown title={<>
                            <FaUserCircle/> {!userInfo?.username ? userInfo?.principal.username : userInfo?.username} </>}
                                     id="basic-nav-dropdown"
                                     className={"button-avatar"}>
                            <NavLink className="nav-link text-transform text-center" to={"/change_password"}>
                                Promjena lozinke
                            </NavLink>
                            <div className="nav-link text-transform text-center cursor-button" onClick={handleOpen2FAModal}>
                                2FA
                            </div>
                            <NavLink className="nav-link text-transform text-center" to={"/login"}
                                     onClick={handleLogOut}>
                                Odjava
                            </NavLink>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
            <TwoFaModal/>
        </Navbar>
    );
};

export default NavBar;

